import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('settings');

export const apiRoutes = {
  helpers: `helpers`,
  helpersUpdate: 'helpers/update',
  showDefaultSettings: `${URI_PREFIX}/show/default`,
  timezones: `${URI_PREFIX}/users/timezones`,
  getUserSettings: `${URI_PREFIX}/users/show`,
  updateUserSettings: `${URI_PREFIX}/users/main/update`,
  showSettings: `${URI_PREFIX}/show/default`,
  getLandingPages: `${URI_PREFIX}/users/landing-pages`,
  updateSettings: `${URI_PREFIX}/admin/main/update`,
  getAllReleaseNotes: `${URI_PREFIX}/release/notes/`,
  getReleaseNote: `${URI_PREFIX}/release/notes/show`,
  storeReleaseNotes: `${URI_PREFIX}/release/notes/store`,
  updateReleaseNotes: `${URI_PREFIX}/release/notes/update`,
  deleteReleaseNotes:`${URI_PREFIX}/release/notes/delete`,
  releaseNotesNotification: `${URI_PREFIX}/release/notes/notification`,
  releaseNotesNotificationMark: `${URI_PREFIX}/release/notes/notification/mark`,
  modules: `${URI_PREFIX}/modules/`,
  releaseNoteVersionAutoComplete: `${URI_PREFIX}/release/notes/version`,
  releaseNoteTitleAutoComplete: `${URI_PREFIX}/release/notes/title`,
  releaseNoteCreateByAutoComplete: `users/activated`,
};
// Notifications
export const URI_PREFIX_NOTI = checkIsStoryBookPath('notifications');
export const apiRoutesNotifications = {
  //Notifications Setting
  modulesActions: `${URI_PREFIX_NOTI}/modules/actions/`,
  userActionsUpdate: `${URI_PREFIX_NOTI}/modules/actions/update`,

  //Notifications Page
  allNotifications: `${URI_PREFIX_NOTI}/`,
  loadNotificationRead: `${URI_PREFIX_NOTI}/read`,

  //Notification popup
  NotificationsCount: `${URI_PREFIX_NOTI}/count`,
  makeNotificationsSeen: `${URI_PREFIX_NOTI}/make-seen`,
  NotificationsInApp: `${URI_PREFIX_NOTI}/in-app`,
};
